function createActionStateSnapshot({ authToken, activeCompanyId, batches, currentUser }) {
  return {
    authToken,
    activeCompanyId,
    batches,
    currentUser,
  };
}

function createActionDeps({
  apiFetch,
  state,
  setRoute,
  setParams,
  setAuthToken,
  setCurrentUser,
  setCompanies,
  setTemplates,
  setUsers,
  setApprovals,
  setBatches,
  setIsSyncing,
  setWorkspaceReady,
  setActiveCompanyId,
  toast,
}) {
  return {
    apiFetch,
    state,
    setRoute,
    setParams,
    setAuthToken,
    setCurrentUser,
    setCompanies,
    setTemplates,
    setUsers,
    setApprovals,
    setBatches,
    setIsSyncing,
    setWorkspaceReady,
    setActiveCompanyId,
    toast,
  };
}

export { createActionStateSnapshot, createActionDeps };
